import { render, staticRenderFns } from "./knowledgecourse.vue?vue&type=template&id=40db42cc&scoped=true"
import script from "./knowledgecourse.vue?vue&type=script&lang=js"
export * from "./knowledgecourse.vue?vue&type=script&lang=js"
import style0 from "./knowledgecourse.vue?vue&type=style&index=0&id=40db42cc&prod&lang=scss&scoped=true"
import style1 from "./knowledgecourse.vue?vue&type=style&index=1&id=40db42cc&prod&lang=scss"
import style2 from "./knowledgecourse.vue?vue&type=style&index=2&id=40db42cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db42cc",
  null
  
)

export default component.exports